export default __webpack_public_path__ + "static/media/weather.49c79179.svg";